<script lang="ts" setup>
import type { MagentoBundleProduct, MagentoCartItemInput } from '~layers/app/types/magento'

export interface Props {
  product: MagentoBundleProduct
  optional?: boolean
}

const show = ref<boolean>(false)

const props = withDefaults(defineProps<Props>(), {
  optional: false,
})

const selectedBundleItems = ref<Record<string, string[]>>({})

const selectedUids = computed<string[]>(() =>
  Object.values(selectedBundleItems.value).flat(),
)

const emit = defineEmits<{
  (event: 'selected', data: Record<string, MagentoCartItemInput>): void
}>()

const oos = computed(() =>
  props.product.stock_status === 'OUT_OF_STOCK' ? [props.product] : [],
)

const cartItemData = computed<MagentoCartItemInput>(() => {
  return {
    quantity: 1,
    sku: props.product.sku,
    selected_options: selectedUids.value,
  }
})

const selected = (reset: boolean | undefined) => {
  console.log('selected bundle items', selectedBundleItems.value)
  emit('selected', {
    [props.product.sku]: reset
      ? null
      : cartItemData.value,
  })
}

onMounted(() => {
  props.product.items.forEach((item: any) => {
    selectedBundleItems.value[item.uid] = [item.options[0]?.uid || '']
  })
  if (props.product.items.some((item: any) => item.options.length !== 1)) {
    show.value = true
  }
  selected(true)
})

watch(selectedBundleItems, (val: Record<string, string[]>) => {
  if (Object.values(val).every((item: string[]) => item.join('') > '')) {
    selected(false)
  }
  else {
    selected(true)
  }
}, { deep: true })
</script>

<template>
  <div>
    <ProductBundleItem
      v-for="item in product.items"
      v-show="show"
      :key="item.uid"
      v-model="selectedBundleItems[item.uid]"
      :settings="item"
    />
    <slot
      name="oos"
      v-bind="{ oos }"
    />
  </div>
</template>
